/**
 * Landing page loads the original Transpots promotional website (index.html, css, js)
 * from the copied assets. Auth links in landing.html use target="_top" to navigate
 * to /auth/login and /auth/signup within the React app.
 */
const LandingPage = () => {
  return (
    <iframe
      src="/landing.html"
      title="Transpots"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        border: 'none',
      }}
    />
  )
}

export default LandingPage
